import styled from "@emotion/styled";
import Form from "global/components/form";

export const Switch = styled(Form.Switch)`
  margin-block-start: 1.33em;
`;
